<template>
  <div>
    <div class="all conent">
      <div class="tabs">
        <div class="tab-item tab-item-active">备件需求</div>
      </div>
      <div>
        <el-form :inline="true"
                 :model="dataForm"
                 @keyup.enter.native="getDataList(1)"
                 @submit.native.prevent
                 label-width="100px">
          <div class="search-row">
            <div class="search-conent">
              <el-form-item label="申请编号：">
                <el-input v-model="dataForm.demandCode"
                          placeholder="申请编号"
                          clearable></el-input>
              </el-form-item>
            </div>
            <div class="search-conent">
              <el-form-item label="状态："
                            prop="typingPerson">
                <el-select v-model="dataForm.status"
                           clearable
                           placeholder="状态">
                  <el-option v-for="item in statusList"
                             :key="item.code"
                             :label="item.value"
                             :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="search-but">
              <button class="info-but"
                      @click="getDataList(1)">查询</button>
            </div>
          </div>
          <div class="search-row">
            <div class="search-conent">
              <el-form-item label="申请时间："
                            prop="equipmentType">
                <el-date-picker v-model="dataForm.dateValue"
                                type="daterange"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                style="width:240px;">
                </el-date-picker>
              </el-form-item>
            </div>
            <div class="search-but">
              <button class="info-but"
                      style="margin-right:0"
                      @click="reset()">重置</button>
            </div>
          </div>
        </el-form>
      </div>
      <div class="opt-row">
        <div class="opt-left">
          <button class="info-but info-but-new"
                  @click="routerHandle('spareRequirementsAdd')"><i class="el-icon-plus"></i>新增</button>
        </div>
      </div>
      <el-table :data="dataList"
                border
                @selection-change="selectionChangeHandle"
                :key="1">
        <el-table-column type="index"
                         width="50"
                         header-align="center"
                         align="center"
                         label="序号"></el-table-column>
        <el-table-column prop="demandCode"
                         header-align="center"
                         align="center"
                         label="申请编号"
                         width="190"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyName"
                         header-align="center"
                         align="left"
                         label="公司名称"
                         show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="applyUserName"
                         header-align="center"
                         align="center"
                         label="申请用户"
                         width="120"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="applyTime"
                         header-align="center"
                         align="center"
                         label="申请时间"
                         width="160"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <div>{{scope.row.applyTime.slice(0,10)}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="status"
                         header-align="center"
                         align="center"
                         label="当前状态"
                         width="100"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.status === 0">待受理</div>
            <div v-if="scope.row.status === 1">待确认</div>
            <!-- <div v-if="scope.row.status === 2">备件中</div> -->
            <div v-if="scope.row.status === 4">已取消</div>
            <div v-if="scope.row.status === 5">已完成</div>
            <div v-if="scope.row.status === 6">已评价</div>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         header-align="center"
                         align="center"
                         width="160"
                         label="操作">
          <template slot-scope="scope">
            <el-button type="text"
                       size="small"
                       @click="openDetailHandle(scope.row.demandId)">查看详情</el-button>
            <el-button type="text"
                       v-if="scope.row.status === 0"
                       size="small"
                       @click="updateHandle(scope.row.demandId)">维护</el-button>
            <el-button type="text"
                       v-if="scope.row.status === 0"
                       size="small"
                       @click="deleteHandle(scope.row.demandId)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination  @size-change="sizeChangeHandle"
                      @current-change="currentChangeHandle"
                      :current-page="currentPage"
                      :page-sizes="[10, 20, 50, 100]"
                      :page-size="pageSize"
                      :total="totalPage"
                      layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
      <!-- <div class="doclist-pagination"
           v-if="dataList.length">
        <div class="doclist-lastpage"
             @click="jumpLastPage">上一页</div>
        <div class="doclist-omit">{{lastOmit}}</div>
        <ul>
          <li :class="item === currentPage?'pageactive':''"
              v-for="item in pageList"
              :key="item"
              @click="changePageTo(item)">{{item}}</li>
        </ul>
        <div class="doclist-omit">{{nextOmit}}</div>
        <div class="doclist-nextpage"
             @click="jumpNextPage">下一页</div>
        <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text"
                 v-model.number="jumpTargetPage">页</div>
        <div class="doclist-jump"
             @click="jumpFarPage">确定</div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      activeStatus: '1',
      selectList: [],
      dataForm: {
        dateValue: '',
        status: '',
        demandCode: ''
      },
      statusList: [
        { code: 0, value: '待受理' },
        { code: 1, value: '待确认' },
        // { code: 2, value: '备件中' },
        { code: 4, value: '已取消' },
        { code: 5, value: '已完成' },
        { code: 6, value: '已评价' }
      ],
      dataList: [],
      // 分页
      currentPage: 1, // 当前页
      totalPage: 4, // 总页数
      pageSize: 10,
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1 // 跳转页
      // pickerOptions: {
      //   disabledDate(time) {
      //     return time.getTime() >= (Date.now())
      //   }
      // }
    }
  },
  methods: {
    changeStatus (val) {
      this.activeStatus = val
    },
    // 多选
    selectionChangeHandle (list) {
      this.selectList = list
    },
    routerHandle (routerName) {
      this.$router.push({ name: routerName })
    },
    // 上一页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    //  下一页
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    //   第几页
    changePageTo (page) {
      this.getDataList(page)
    },
    //   确定跳转到哪页
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        this.changePageTo(this.jumpTargetPage)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.currentPage = val
      this.getDataList()
    },
    getDataList (currentPage = this.currentPage) {
      let params = {
        page: currentPage,
        limit: this.pageSize,
        status: this.dataForm.status,
        startDate: this.dataForm.dateValue
          ? this.dataForm.dateValue[0]
          : '',
        endDate: this.dataForm.dateValue ? this.dataForm.dateValue[1] : '',
        demandCode: this.dataForm.demandCode,
        companyId: localStorage.getItem('defaultCompanyId') !== '' ? localStorage.getItem('defaultCompanyId') : null
      }
      this.$http.post(`/front/order/lclb/demand/listByOrdinary`, params)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.dataList = res.data.data || []
            // this.totalPage = Math.ceil(res.data.count / 10)
            this.totalPage = res.data.count
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.setPageTo(currentPage)
        })
        .catch(() => {
          this.dataList = []
        })
    },
    setPageTo (page) {
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [
            this.totalPage - 4,
            this.totalPage - 3,
            this.totalPage - 2,
            this.totalPage - 1,
            this.totalPage
          ]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
    },
    // 清空form
    reset () {
      this.dataForm = {
        dateValue: '',
        status: '',
        demandCode: ''
      }
      this.getDataList(1)
    },
    // 跳转详情
    openDetailHandle (id) {
      this.$router.push({ name: 'spareRequirementsDetail', query: { id: id } })
    },
    updateHandle (id) {
      this.$router.push({ name: 'spareRequirementsUpdate', query: { id: id } })
    },
    deleteHandle (id) {
      // if (row.presaleStatus === 0 || row.presaleStatus === 1) {
      //     this.deleteData(row.presaleId)
      // } else if (row.presaleStatus === 2) {
      //   this.$message.error('待客户确认不可删除')
      // }
      this.deleteData(id)
    },
    deleteData (id) {
      this.$confirm(`${this.$t('message.confirmDeleteRequisition')}?`, this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.$http
          .post(
            `/front/order/lclb/demand/deleteByOrdinary`,
            {
              demandId: id
            }
          )
          .then(({ data: res }) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('message.delete'),
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.getDataList()
                }
              })
            }
          })
          .catch(() => {})
      })
    }
  },
  mounted () {
    this.getDataList()
  }
}
</script>
<style scoped>
.conent {
  width: 970px;
  padding: 20px 20px;
}
.search-row {
  display: flex;
}
.search-conent {
  min-width: 350px;
  margin-right: 20px;
}
.search-but {
  width: 100%;
  min-width: 200px;
  text-align: right;
}
.opt-row {
  width: 100%;
  display: flex;
  text-align: right;
  margin-bottom: 20px;
}
.opt-right {
  width: 300px;
}
.opt-left {
  width: 100%;
  text-align: left;
}
.info-but {
  background: #ffffff;
  width: 96px;
  height: 40px;
  text-align: center;
  line-height: 38px;
  font-size: 14px;
  color: #1d65a8;
  letter-spacing: 0;
  border: none;
  cursor: pointer;
  user-select: none;
  border: 1px solid #1d65a8;
  margin-right: 10px;
}
.info-but:hover {
  background: #1d65a8;
  color: #ffffff;
}
.info-but-new {
  background: #1d65a8;
  color: #ffffff;
}
.but-file {
  background-color: #ffffff;
  border: none;
}
.demand-desc {
  width: 100%;
  cursor: pointer;
}
.tip {
  max-width: 500px;
  word-wrap: break-word;
  word-break: break-all;
}
.red {
  color: red;
}
.detail-icon {
  cursor: pointer;
}
.detail-icon:hover {
  color: #1d65a8;
}
.tooltip-content {
  width: 60px;
  text-align: center;
  border-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.short-content {
  max-height: 69px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tabs{
  height: 48px;
  margin: 0 69px;
}
.tab-item{
  display: inline-block;
  /* padding: 12px 16px; */
  text-align: center;
  background: #FFFFFF;
  /* box-shadow: inset 0 -1px 0 0 #DDDDDD; */
  /* width: 88px; */
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  letter-spacing: 0;
  margin-right: 24px;
  cursor: pointer;
}
.tab-item-active{
  color: #1D65A8;
  border-bottom: 2px solid #1D65A8;
}
.tab-item-content{
  padding-top: 10px;
}
</style>
